import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid/main';
import { PacketPopupBackendService } from '../service/packet/packet-popup-backend.service';

@Component({
  selector: 'lfwms-cc-qty-cell-renderer',
  templateUrl: './filename-cell-renderer.component.html',
  styleUrls: ['./filename-cell-renderer.component.css'],
  providers: [PacketPopupBackendService]
})
export class WOPacketCellRendererComponent implements ICellRendererAngularComp {

  public isLoading: boolean = true;
  public params: any;
  public templateId: number = 0;
  public cellValue: any = [];
  public cellDataRef: any = [];
  public cellDisplayValue: any;

  constructor(protected backendService: PacketPopupBackendService) { }

  public agInit(params: ICellRendererParams): void {
    this.params = params;
  }


  public refresh(params: any): boolean {
    this.params = params;
    if (this.params.column.colDef.colId === 'isSelected') {
      this.cellValue = this.params.value;
    } else {
      this.cellValue = this.params.value.cVal;
    }
    return true;
  }

  public downloadFile(filePath) {
    this.backendService.downloadFile(filePath);
  }
}




// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/inventory/work-order-management/work-order-execution/work-orders/aggrid-custom-cell/filename-cell-renderer.component.ts